import { Profile } from "../../../types";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Save, X } from "lucide-react";

interface ContactEditFormProps {
  editedProfile: Profile;
  onProfileChange: (updatedProfile: Profile) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const ContactEditForm = ({
  editedProfile,
  onProfileChange,
  onSave,
  onCancel,
}: ContactEditFormProps) => {
  const handleInputChange = (field: keyof Profile, value: string) => {
    onProfileChange({
      ...editedProfile,
      [field]: value,
    });
  };

  return (
    <div className="space-y-6 mt-6 animate-fade-up">
      <div className="flex justify-end mb-4 space-x-2">
        <Button variant="outline" size="sm" onClick={onCancel}>
          <X className="h-4 w-4 mr-2" />
          Cancel
        </Button>
        <Button size="sm" onClick={onSave}>
          <Save className="h-4 w-4 mr-2" />
          Save
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <p className="text-sm text-muted-foreground mb-2">First Name</p>
          <Input
            value={editedProfile.first_name || ''}
            onChange={(e) => handleInputChange('first_name', e.target.value)}
          />
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-2">Last Name</p>
          <Input
            value={editedProfile.last_name || ''}
            onChange={(e) => handleInputChange('last_name', e.target.value)}
          />
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-2">Email</p>
          <Input
            value={editedProfile.email || ''}
            onChange={(e) => handleInputChange('email', e.target.value)}
          />
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-2">Phone</p>
          <Input
            value={editedProfile.phone || ''}
            onChange={(e) => handleInputChange('phone', e.target.value)}
          />
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-2">Street</p>
          <Input
            value={editedProfile.street || ''}
            onChange={(e) => handleInputChange('street', e.target.value)}
          />
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-2">City</p>
          <Input
            value={editedProfile.city || ''}
            onChange={(e) => handleInputChange('city', e.target.value)}
          />
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-2">State</p>
          <Input
            value={editedProfile.state || ''}
            onChange={(e) => handleInputChange('state', e.target.value)}
          />
        </div>
        <div>
          <p className="text-sm text-muted-foreground mb-2">ZIP Code</p>
          <Input
            value={editedProfile.zip_code || ''}
            onChange={(e) => handleInputChange('zip_code', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};